// Custom "Sort by" dropdown — a styled <details>/<summary> listbox that drives a hidden
// native <select name="sort_by">, so the existing facets form/AJAX filtering logic
// (which listens for 'input' events on the form) keeps working unchanged.
// Wrapped in an IIFE with an early guard since this script may be included more than once
// per page (desktop + mobile sort instances), and a bare top-level `class` would otherwise
// throw a redeclaration error the second time it runs.
(function () {
  if (customElements.get('vsort-select')) return;

  class VsortSelect extends HTMLElement {
    connectedCallback() {
      this.select = this.previousElementSibling;
      if (!this.select || this.select.tagName !== 'SELECT') return;

      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('click', this.onDocumentClick.bind(this));
    }

    onClick(event) {
      const option = event.target.closest('.vsort__option');
      if (!option) return;

      const details = this.querySelector('details');
      const value = option.dataset.value;

      if (this.select.value !== value) {
        this.select.value = value;
        this.select.dispatchEvent(new Event('input', { bubbles: true }));
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.querySelectorAll('.vsort__option').forEach((btn) => {
        btn.classList.toggle('vsort__option--active', btn === option);
      });
      this.querySelectorAll('[role="option"]').forEach((li) => {
        li.setAttribute('aria-selected', li.contains(option) ? 'true' : 'false');
      });

      const current = this.querySelector('.vsort__current');
      if (current) current.textContent = option.textContent.trim();

      if (details) {
        details.removeAttribute('open');
        details.querySelector('summary')?.focus();
      }
    }

    onDocumentClick(event) {
      if (this.contains(event.target)) return;
      const details = this.querySelector('details');
      if (details && details.hasAttribute('open')) details.removeAttribute('open');
    }
  }

  customElements.define('vsort-select', VsortSelect);
})();
